import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

type ProgressBarAttributes = {
  progress: number;
};

export default styled.div(
  ({ progress }: ProgressBarAttributes) => css`
    --margin: min(6.4vmin, 24px);
    /* Button width (40) + distance (24) = 64px */
    --width: calc(100vw - (var(--margin) * 2 + 64px));

    top: calc(min(12.8vmin, 48px) + 14px);
    background-color: #fff1cc;

    right: var(--margin);
    border-radius: 16px;
    width: var(--width);

    position: absolute;
    overflow: hidden;
    display: block;
    height: 12px;

    &::after {
      transform: translateX(-${100 - progress}%);
      background-color: ${Theme.color.orange};
      transition: transform 0.3s ease-in-out;

      border-radius: 16px;
      position: absolute;

      content: '';
      width: 100%;
      height: 100%;

      left: 0px;
      top: 0px;
    }
  `
);
